export enum MovimentacoesTypes {
  'LOAD_REQUEST' = '@movimentacoes/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@movimentacoes/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@movimentacoes/LOAD_FAILURE',

  'ETAPA_REQUEST' = '@movimentacoes/ETAPA_REQUEST',
  'ETAPA_SUCCESS' = '@movimentacoes/ETAPA_SUCCESS',
  'ETAPA_FAILURE' = '@movimentacoes/ETAPA_FAILURE',

  'ITENS_NOTA_REQUEST_ENTRADA' = '@movimentacoes/ITENS_NOTA_REQUEST_ENTRADA',
  'ITENS_NOTA_SUCCESS_ENTRADA' = '@movimentacoes/ITENS_NOTA_SUCCESS_ENTRADA',
  'ITENS_NOTA_FAILURE_ENTRADA' = '@movimentacoes/ITENS_NOTA_FAILURE_ENTRADA',

  'FILTER_Movimentacoes' = '@movimentacoes/FILTER_Movimentacoes',

  'SORTER_Movimentacoes' = '@movimentacoes/SORTER_Movimentacoes',

  'CLEAN_DETALHES_ITENS_NOTA' = '@movimentacoesSaida/CLEAN_DETALHES_ITENS_NOTA',

  'CLEAN_MOVIENTRADA' = '@movimentacoes/CLEAN_MOVIENTRADA',
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface Sorter {
  sortBy: string;
  ascendance: string;
}
export interface IMovimentacoes {
  nuNota: number;
  numNota: number;
  ocorrencia: boolean;
  dtEmissao: Date;
  dtLancamento: Date;
  status: string;
  inscricaoEstadualParceiro: string;
  emissorNF: string;
  emitente: string;
  proprietarioMercadoria: string;
  pagadorArmazenagem: string;
  tempoArmazenagemContratado: number;
  tempoRestante: number;
  pesoBruto: number;
  vlrMercadoria: number;
  itensNota: string;
  chaveNfe: string;
  parceiro: string;
  codParceiro: number;
}

export interface IItensNota {
  nuNota: number;
  volume: string;
  quantidade: number;
  descricaoProduto: string;
  codProduto: number;
  controle: string;
  referencia: string;
  quantidadePendente: number;
  valorTotal: number;
  pesoBruto: number;
}

export interface IFilter {
  filter: object | undefined;
  codParceiro: number;
}

export interface IFiltroMovi {
  numNota: number;
  nuNota: number;
  periodoLacamentoInicio: Date;
  periodoLacamentoFim: Date;
  periodoEmissaoInicio: Date;
  periodoEmissaoFim: Date;
  produto: string;
  emissorNota: string;
  chaveNfe: string;
  pagadorArmazenagem: string;
}

export interface EtapaNota {
  valor: string;
  opcao: string;
}

export interface MovimentacoesState {
  readonly data: IMovimentacoes[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly pagination: Pagination;
  readonly ordenacao: Sorter;
  readonly etapa?: EtapaNota[];
  readonly etapaloading: boolean;
  readonly etapaerror: boolean;
  readonly itensNotaEntrada: IItensNota[];
  readonly filter?: IFilter;
  readonly sorter?: any;
}
